import { useState, useContext } from "react";
import {
  Stack,
  Box,
  Avatar,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment from "moment";
//Srcs
import "./dashboardstyle.scss";
import "../../Style/pagestyle.scss";
import EmptyData from "../Include/EmptyData/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import { AuthContext } from "../../Context/AuthContext";
import useGetStudentByEnrollmentStatus from "../../Hooks/useGetStudentByEnrollmentStatus";

export default function StudentCompleteClass() {
  const { t } = useContext(AuthContext);
  let navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [payAs, setPayAs] = useState("month");
  const limit = 4;

  const { loading, tableData, totalCount } = useGetStudentByEnrollmentStatus({
    page,
    limit,
    status: "complete",
    payAs: payAs,
  });

  // console.log("totalCount::", totalCount, tableData);
  const totalPages = Math.ceil(totalCount / limit);

  return (
    <div className="chart-container">
      <Stack
        direction="column"
        justifyContent="space-between"
        sx={{ height: "100%" }}
      >
        <Stack direction="column" spacing={2}>
          <Stack
            direction="row"
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography className={t("chart-title")}>
              {t("student_complete_class")} ({totalCount} {t("pax")})
            </Typography>

            <FormControl size="small" sx={{ width: "30%" }}>
              <Select value={payAs} onChange={(e) => setPayAs(e.target.value)}>
                <MenuItem value="month">Month</MenuItem>
                <MenuItem value="course">Course</MenuItem>
              </Select>
            </FormControl>
          </Stack>

          {loading ? (
            <Stack
              direction="column"
              justifyContent="center"
              sx={{ height: "300px" }}
            >
              <LoadingPage />
            </Stack>
          ) : tableData?.length === 0 ? (
            <Stack
              direction="column"
              justifyContent="center"
              sx={{ height: "300px" }}
            >
              <EmptyData />
            </Stack>
          ) : (
            <Stack direction="column" spacing={1}>
              {tableData?.map((row, index) => {
                return (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    key={index}
                    className="student-card"
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(
                        `/class/class-detail?classId=${row?.classId?._id}`,
                      )
                    }
                  >
                    <Stack direction="row" spacing={1.4}>
                      <Stack direction="column" justifyContent="center">
                        <Avatar
                          sx={{ width: 40, height: 40 }}
                          alt={row?.studentId?.studentName}
                          src={row?.studentId?.profile}
                        />
                      </Stack>
                      <Stack direction="column" justifyContent="center">
                        <Typography className="student-name">
                          {row?.studentId?.familyName +
                            " " +
                            row?.studentId?.studentName}
                        </Typography>
                        <Typography className="student-status">
                          {row?.studentId?.gender}
                        </Typography>
                      </Stack>
                    </Stack>

                    <Stack
                      direction="column"
                      spacing={0.6}
                      justifyContent="center"
                    >
                      <Typography className="class-name">
                        {row?.classId?.courseId?.enName +
                          " " +
                          row?.classId?.className}
                      </Typography>
                      <Typography className="date-name">
                        {moment(row?.completedDate).format("DD/MMM/YYYY")}
                      </Typography>
                    </Stack>
                  </Stack>
                );
              })}
            </Stack>
          )}
        </Stack>

        {/* ==================== Pagination  ============================= */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button
            className="btn-next"
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            Previous
          </Button>
          <Button
            className="btn-next"
            disabled={page === totalPages}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Next
          </Button>
        </Box>
      </Stack>
    </div>
  );
}
